import { render, staticRenderFns } from "./c-schedule-item.vue?vue&type=template&id=2dbffcaf&scoped=true"
import script from "./c-schedule-item.vue?vue&type=script&lang=js"
export * from "./c-schedule-item.vue?vue&type=script&lang=js"
import style0 from "./c-schedule-item.vue?vue&type=style&index=0&id=2dbffcaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbffcaf",
  null
  
)

export default component.exports